import { Check, Circle } from 'lucide-react'

type PasswordRule = {
  label: string
  test: (password: string) => boolean
}

export function PasswordChecklist({
  password,
  passwordRules,
}: {
  password: string
  passwordRules: PasswordRule[]
}) {
  return (
    <div className="mt-2 grid grid-cols-2 gap-x-4 gap-y-1.5">
      {passwordRules.map((rule) => {
        const isValid = password.length > 0 && rule.test(password)
        return (
          <div
            key={rule.label}
            className="flex items-center gap-2 text-sm transition-colors duration-200"
          >
            {isValid ? (
              <Check className="size-4 text-system-state-success" />
            ) : (
              <Circle className="size-4 text-neutral-300" />
            )}
            <span
              className={
                isValid ? 'text-system-state-success' : 'text-neutral-500'
              }
            >
              {rule.label}
            </span>
          </div>
        )
      })}
    </div>
  )
}
